// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_k0-0";
export var animationContainer = "_k0-1";
export var itemPrice = "_k0-a";
export var itemizedContent = "_k0-9";
export var itemizedHeader = "_k0-7";
export var itemizedRow = "_k0-8";
export var itemizedSection = "_k0-6";
export var modalContent = "_k0-2";
export var orderName = "_k0-3";
export var refundOption = "_k0-4";
export var refundOptionsContainer = "_k0-5";
export var shippingLabel = "_k0-b";
export var totalRow = "_k0-c";